module.exports = __webpack_public_path__ + "img/en.f9aa1c5c.png";